import { BaseEnum } from "../../BaseEnum";

export class FugitiveGas extends BaseEnum {
  static CARBON_DIOXIDE = 1;
  static METHANE = 2;
  static NITROUS_OXIDE = 3;
  static HFC_23 = 4;
  static HFC_32 = 5;
  static HFC_41 = 6;
  static HFC_125 = 7;
  static HFC_134 = 8;
  static HFC_134A = 9;
  static HFC_143 = 10;
  static HFC_143A = 11;
  static HFC_152A = 12;
  static HFC_227EA = 13;
  static HFC_236FA = 14;
  static HFC_245FA = 15;
  static HFC_43_I0MEE = 16;
  static PERFLUOROMETHANE_PFC_14 = 17;
  static PERFLUOROETHANE_PFC_116 = 18;
  static PERFLUOROPROPANE_PFC_218 = 19;
  static PERFLUOROCYCLOBUTANE_PFC_318 = 20;
  static PERFLUOROBUTANE_PFC_3_1_10 = 21;
  static PERFLUOROPENTANE_PFC_4_1_12 = 22;
  static PERFLUOROHEXANE_PFC_5_1_14 = 23;
  static PFC_9_1_18 = 24;
  static PERFLUOROCYCLOPROPANE = 25;
  static SULPHUR_HEXAFLUORIDE_SF6 = 26;
  static HFC_152 = 27;
  static HFC_161 = 28;
  static HFC_236CB = 29;
  static HFC_236EA = 30;
  static HFC_245CA = 31;
  static HFC_365MFC = 32;
  static NITROGEN_TRIFLUORIDE = 33;
  static R401A = 34;
  static R401B = 35;
  static R401C = 36;
  static R402A = 37;
  static R402B = 38;
  static R403A = 39;
  static R403B = 40;
  static R404A = 41;
  static R405A = 42;
  static R406A = 43;
  static R407A = 44;
  static R407B = 45;
  static R407C = 46;
  static R407D = 47;
  static R407E = 48;
  static R407F = 49;
  static R408A = 50;
  static R409A = 51;
  static R409B = 52;
  static R410A = 53;
  static R410B = 54;
  static R411A = 55;
  static R411B = 56;
  static R412A = 57;
  static R413A = 58;
  static R414A = 59;
  static R414B = 60;
  static R415A = 61;
  static R415B = 62;
  static R416A = 63;
  static R417A = 64;
  static R417B = 65;
  static R417C = 66;
  static R418A = 67;
  static R419A = 68;
  static R419B = 69;
  static R420A = 70;
  static R421A = 71;
  static R421B = 72;
  static R422A = 73;
  static R422B = 74;
  static R422C = 75;
  static R422D = 76;
  static R422E = 77;
  static R423A = 78;
  static R424A = 79;
  static R425A = 80;
  static R426A = 81;
  static R427A = 82;
  static R428A = 83;
  static R429A = 84;
  static R430A = 85;
  static R431A = 86;
  static R432A = 87;
  static R433A = 88;
  static R433B = 89;
  static R433C = 90;
  static R434A = 91;
  static R435A = 92;
  static R436A = 93;
  static R436B = 94;
  static R437A = 95;
  static R438A = 96;
  static R439A = 97;
  static R440A = 98;
  static R441A = 99;
  static R442A = 100;
  static R443A = 101;
  static R444A = 102;
  static R445A = 103;
  static R500 = 104;
  static R501 = 105;
  static R502 = 106;
  static R503 = 107;
  static R504 = 108;
  static R505 = 109;
  static R506 = 110;
  static R507A = 111;
  static R508A = 112;
  static R508B = 113;
  static R509A = 114;
  static R510A = 115;
  static R511A = 116;
  static R512A = 117;
  static CFC_11_R11_TRICHLOROFLUOROMETHANE = 118;
  static CFC_12_R12_DICHLORODIFLUOROMETHANE = 119;
  static CFC_13 = 120;
  static CFC_113 = 121;
  static CFC_114 = 122;
  static CFC_115 = 123;
  static HALON_1211 = 124;
  static HALON_1301 = 125;
  static HALON_2402 = 126;
  static CARBON_TETRACHLORIDE = 127;
  static METHYL_BROMIDE = 128;
  static METHYL_CHLOROFORM = 129;
  static HCFC_22_R22_CHLORODIFLUOROMETHANE = 130;
  static HCFC_123 = 131;
  static HCFC_124 = 132;
  static HCFC_141B = 133;
  static HCFC_142B = 134;
  static HCFC_225CA = 135;
  static HCFC_225CB = 136;
  static HCFC_21 = 137;
  static HFE_125 = 138;
  static HFE_134 = 139;
  static HFE_143A = 140;
  static HCFE_235DA2 = 141;
  static HFE_245CB2 = 142;
  static HFE_245FA2 = 143;
  static HFE_254CB2 = 144;
  static HFE_347MCC3 = 145;
  static HFE_347PCF2 = 146;
  static HFE_356PCC3 = 147;
  static HFE_449SL_HFE_7100 = 148;
  static HFE_569SF2_HFE_7200 = 149;
  static HFE_43_10PCCC124_H_GALDEN1040X = 150;
  static HFE_236CA12_HG_10 = 151;
  static HFE_338PCC13_HG_01 = 152;
  static TRIFLUOROMETHYL_SULPHUR_PENTAFLUORIDE = 153;
  static PFPMIE = 154;
  static DIMETHYLETHER = 155;
  static METHYLENE_CHLORIDE = 156;
  static METHYL_CHLORIDE = 157;
  static R290_PROPANE = 158;
  static R600A_ISOBUTANE = 159;
  static R600_BUTANE = 160;
  static R601_PENTANE = 161;
  static R601A_ISOPENTANE = 162;
  static R170_ETHANE = 163;
  static R1270_PROPENE = 164;

  static Codes = [
    this.CARBON_DIOXIDE,
    this.METHANE,
    this.NITROUS_OXIDE,
    this.HFC_23,
    this.HFC_32,
    this.HFC_41,
    this.HFC_125,
    this.HFC_134,
    this.HFC_134A,
    this.HFC_143,
    this.HFC_143A,
    this.HFC_152A,
    this.HFC_227EA,
    this.HFC_236FA,
    this.HFC_245FA,
    this.HFC_43_I0MEE,
    this.PERFLUOROMETHANE_PFC_14,
    this.PERFLUOROETHANE_PFC_116,
    this.PERFLUOROPROPANE_PFC_218,
    this.PERFLUOROCYCLOBUTANE_PFC_318,
    this.PERFLUOROBUTANE_PFC_3_1_10,
    this.PERFLUOROPENTANE_PFC_4_1_12,
    this.PERFLUOROHEXANE_PFC_5_1_14,
    this.PFC_9_1_18,
    this.PERFLUOROCYCLOPROPANE,
    this.SULPHUR_HEXAFLUORIDE_SF6,
    this.HFC_152,
    this.HFC_161,
    this.HFC_236CB,
    this.HFC_236EA,
    this.HFC_245CA,
    this.HFC_365MFC,
    this.NITROGEN_TRIFLUORIDE,
    this.R401A,
    this.R401B,
    this.R401C,
    this.R402A,
    this.R402B,
    this.R403A,
    this.R403B,
    this.R404A,
    this.R405A,
    this.R406A,
    this.R407A,
    this.R407B,
    this.R407C,
    this.R407D,
    this.R407E,
    this.R407F,
    this.R408A,
    this.R409A,
    this.R409B,
    this.R410A,
    this.R410B,
    this.R411A,
    this.R411B,
    this.R412A,
    this.R413A,
    this.R414A,
    this.R414B,
    this.R415A,
    this.R415B,
    this.R416A,
    this.R417A,
    this.R417B,
    this.R417C,
    this.R418A,
    this.R419A,
    this.R419B,
    this.R420A,
    this.R421A,
    this.R421B,
    this.R422A,
    this.R422B,
    this.R422C,
    this.R422D,
    this.R422E,
    this.R423A,
    this.R424A,
    this.R425A,
    this.R426A,
    this.R427A,
    this.R428A,
    this.R429A,
    this.R430A,
    this.R431A,
    this.R432A,
    this.R433A,
    this.R433B,
    this.R433C,
    this.R434A,
    this.R435A,
    this.R436A,
    this.R436B,
    this.R437A,
    this.R438A,
    this.R439A,
    this.R440A,
    this.R441A,
    this.R442A,
    this.R443A,
    this.R444A,
    this.R445A,
    this.R500,
    this.R501,
    this.R502,
    this.R503,
    this.R504,
    this.R505,
    this.R506,
    this.R507A,
    this.R508A,
    this.R508B,
    this.R509A,
    this.R510A,
    this.R511A,
    this.R512A,
    this.CFC_11_R11_TRICHLOROFLUOROMETHANE,
    this.CFC_12_R12_DICHLORODIFLUOROMETHANE,
    this.CFC_13,
    this.CFC_113,
    this.CFC_114,
    this.CFC_115,
    this.HALON_1211,
    this.HALON_1301,
    this.HALON_2402,
    this.CARBON_TETRACHLORIDE,
    this.METHYL_BROMIDE,
    this.METHYL_CHLOROFORM,
    this.HCFC_22_R22_CHLORODIFLUOROMETHANE,
    this.HCFC_123,
    this.HCFC_124,
    this.HCFC_141B,
    this.HCFC_142B,
    this.HCFC_225CA,
    this.HCFC_225CB,
    this.HCFC_21,
    this.HFE_125,
    this.HFE_134,
    this.HFE_143A,
    this.HCFE_235DA2,
    this.HFE_245CB2,
    this.HFE_245FA2,
    this.HFE_254CB2,
    this.HFE_347MCC3,
    this.HFE_347PCF2,
    this.HFE_356PCC3,
    this.HFE_449SL_HFE_7100,
    this.HFE_569SF2_HFE_7200,
    this.HFE_43_10PCCC124_H_GALDEN1040X,
    this.HFE_236CA12_HG_10,
    this.HFE_338PCC13_HG_01,
    this.TRIFLUOROMETHYL_SULPHUR_PENTAFLUORIDE,
    this.PFPMIE,
    this.DIMETHYLETHER,
    this.METHYLENE_CHLORIDE,
    this.METHYL_CHLORIDE,
    this.R290_PROPANE,
    this.R600A_ISOBUTANE,
    this.R600_BUTANE,
    this.R601_PENTANE,
    this.R601A_ISOPENTANE,
    this.R170_ETHANE,
    this.R1270_PROPENE,
  ];

  static _labelKeys = [
    "enums.fugitive-gas.CARBON_DIOXIDE",
    "enums.fugitive-gas.METHANE",
    "enums.fugitive-gas.NITROUS_OXIDE",
    "enums.fugitive-gas.HFC_23",
    "enums.fugitive-gas.HFC_32",
    "enums.fugitive-gas.HFC_41",
    "enums.fugitive-gas.HFC_125",
    "enums.fugitive-gas.HFC_134",
    "enums.fugitive-gas.HFC_134A",
    "enums.fugitive-gas.HFC_143",
    "enums.fugitive-gas.HFC_143A",
    "enums.fugitive-gas.HFC_152A",
    "enums.fugitive-gas.HFC_227EA",
    "enums.fugitive-gas.HFC_236FA",
    "enums.fugitive-gas.HFC_245FA",
    "enums.fugitive-gas.HFC_43_I0MEE",
    "enums.fugitive-gas.PERFLUOROMETHANE_PFC_14",
    "enums.fugitive-gas.PERFLUOROETHANE_PFC_116",
    "enums.fugitive-gas.PERFLUOROPROPANE_PFC_218",
    "enums.fugitive-gas.PERFLUOROCYCLOBUTANE_PFC_318",
    "enums.fugitive-gas.PERFLUOROBUTANE_PFC_3_1_10",
    "enums.fugitive-gas.PERFLUOROPENTANE_PFC_4_1_12",
    "enums.fugitive-gas.PERFLUOROHEXANE_PFC_5_1_14",
    "enums.fugitive-gas.PFC_9_1_18",
    "enums.fugitive-gas.PERFLUOROCYCLOPROPANE",
    "enums.fugitive-gas.SULPHUR_HEXAFLUORIDE_SF6",
    "enums.fugitive-gas.HFC_152",
    "enums.fugitive-gas.HFC_161",
    "enums.fugitive-gas.HFC_236CB",
    "enums.fugitive-gas.HFC_236EA",
    "enums.fugitive-gas.HFC_245CA",
    "enums.fugitive-gas.HFC_365MFC",
    "enums.fugitive-gas.NITROGEN_TRIFLUORIDE",
    "enums.fugitive-gas.R401A",
    "enums.fugitive-gas.R401B",
    "enums.fugitive-gas.R401C",
    "enums.fugitive-gas.R402A",
    "enums.fugitive-gas.R402B",
    "enums.fugitive-gas.R403A",
    "enums.fugitive-gas.R403B",
    "enums.fugitive-gas.R404A",
    "enums.fugitive-gas.R405A",
    "enums.fugitive-gas.R406A",
    "enums.fugitive-gas.R407A",
    "enums.fugitive-gas.R407B",
    "enums.fugitive-gas.R407C",
    "enums.fugitive-gas.R407D",
    "enums.fugitive-gas.R407E",
    "enums.fugitive-gas.R407F",
    "enums.fugitive-gas.R408A",
    "enums.fugitive-gas.R409A",
    "enums.fugitive-gas.R409B",
    "enums.fugitive-gas.R410A",
    "enums.fugitive-gas.R410B",
    "enums.fugitive-gas.R411A",
    "enums.fugitive-gas.R411B",
    "enums.fugitive-gas.R412A",
    "enums.fugitive-gas.R413A",
    "enums.fugitive-gas.R414A",
    "enums.fugitive-gas.R414B",
    "enums.fugitive-gas.R415A",
    "enums.fugitive-gas.R415B",
    "enums.fugitive-gas.R416A",
    "enums.fugitive-gas.R417A",
    "enums.fugitive-gas.R417B",
    "enums.fugitive-gas.R417C",
    "enums.fugitive-gas.R418A",
    "enums.fugitive-gas.R419A",
    "enums.fugitive-gas.R419B",
    "enums.fugitive-gas.R420A",
    "enums.fugitive-gas.R421A",
    "enums.fugitive-gas.R421B",
    "enums.fugitive-gas.R422A",
    "enums.fugitive-gas.R422B",
    "enums.fugitive-gas.R422C",
    "enums.fugitive-gas.R422D",
    "enums.fugitive-gas.R422E",
    "enums.fugitive-gas.R423A",
    "enums.fugitive-gas.R424A",
    "enums.fugitive-gas.R425A",
    "enums.fugitive-gas.R426A",
    "enums.fugitive-gas.R427A",
    "enums.fugitive-gas.R428A",
    "enums.fugitive-gas.R429A",
    "enums.fugitive-gas.R430A",
    "enums.fugitive-gas.R431A",
    "enums.fugitive-gas.R432A",
    "enums.fugitive-gas.R433A",
    "enums.fugitive-gas.R433B",
    "enums.fugitive-gas.R433C",
    "enums.fugitive-gas.R434A",
    "enums.fugitive-gas.R435A",
    "enums.fugitive-gas.R436A",
    "enums.fugitive-gas.R436B",
    "enums.fugitive-gas.R437A",
    "enums.fugitive-gas.R438A",
    "enums.fugitive-gas.R439A",
    "enums.fugitive-gas.R440A",
    "enums.fugitive-gas.R441A",
    "enums.fugitive-gas.R442A",
    "enums.fugitive-gas.R443A",
    "enums.fugitive-gas.R444A",
    "enums.fugitive-gas.R445A",
    "enums.fugitive-gas.R500",
    "enums.fugitive-gas.R501",
    "enums.fugitive-gas.R502",
    "enums.fugitive-gas.R503",
    "enums.fugitive-gas.R504",
    "enums.fugitive-gas.R505",
    "enums.fugitive-gas.R506",
    "enums.fugitive-gas.R507A",
    "enums.fugitive-gas.R508A",
    "enums.fugitive-gas.R508B",
    "enums.fugitive-gas.R509A",
    "enums.fugitive-gas.R510A",
    "enums.fugitive-gas.R511A",
    "enums.fugitive-gas.R512A",
    "enums.fugitive-gas.CFC_11_R11_TRICHLOROFLUOROMETHANE",
    "enums.fugitive-gas.CFC_12_R12_DICHLORODIFLUOROMETHANE",
    "enums.fugitive-gas.CFC_13",
    "enums.fugitive-gas.CFC_113",
    "enums.fugitive-gas.CFC_114",
    "enums.fugitive-gas.CFC_115",
    "enums.fugitive-gas.HALON_1211",
    "enums.fugitive-gas.HALON_1301",
    "enums.fugitive-gas.HALON_2402",
    "enums.fugitive-gas.CARBON_TETRACHLORIDE",
    "enums.fugitive-gas.METHYL_BROMIDE",
    "enums.fugitive-gas.METHYL_CHLOROFORM",
    "enums.fugitive-gas.HCFC_22_R22_CHLORODIFLUOROMETHANE",
    "enums.fugitive-gas.HCFC_123",
    "enums.fugitive-gas.HCFC_124",
    "enums.fugitive-gas.HCFC_141B",
    "enums.fugitive-gas.HCFC_142B",
    "enums.fugitive-gas.HCFC_225CA",
    "enums.fugitive-gas.HCFC_225CB",
    "enums.fugitive-gas.HCFC_21",
    "enums.fugitive-gas.HFE_125",
    "enums.fugitive-gas.HFE_134",
    "enums.fugitive-gas.HFE_143A",
    "enums.fugitive-gas.HCFE_235DA2",
    "enums.fugitive-gas.HFE_245CB2",
    "enums.fugitive-gas.HFE_245FA2",
    "enums.fugitive-gas.HFE_254CB2",
    "enums.fugitive-gas.HFE_347MCC3",
    "enums.fugitive-gas.HFE_347PCF2",
    "enums.fugitive-gas.HFE_356PCC3",
    "enums.fugitive-gas.HFE_449SL_HFE_7100",
    "enums.fugitive-gas.HFE_569SF2_HFE_7200",
    "enums.fugitive-gas.HFE_43_10PCCC124_H_GALDEN1040X",
    "enums.fugitive-gas.HFE_236CA12_HG_10",
    "enums.fugitive-gas.HFE_338PCC13_HG_01",
    "enums.fugitive-gas.TRIFLUOROMETHYL_SULPHUR_PENTAFLUORIDE",
    "enums.fugitive-gas.PFPMIE",
    "enums.fugitive-gas.DIMETHYLETHER",
    "enums.fugitive-gas.METHYLENE_CHLORIDE",
    "enums.fugitive-gas.METHYL_CHLORIDE",
    "enums.fugitive-gas.R290_PROPANE",
    "enums.fugitive-gas.R600A_ISOBUTANE",
    "enums.fugitive-gas.R600_BUTANE",
    "enums.fugitive-gas.R601_PENTANE",
    "enums.fugitive-gas.R601A_ISOPENTANE",
    "enums.fugitive-gas.R170_ETHANE",
    "enums.fugitive-gas.R1270_PROPENE",
  ];
}
